// mutations-types
const SET_TITLE = "SET_TITLE"; // 页面标题

export default {
    namespaced: true,
    state: {
        title: ""
    },
    mutations: {
        [SET_TITLE] (state, data) {
            state.title = data;
        }
    },
    getters: {
        title (state) {
            return state.title;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/title.js